var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkbox-element',{attrs:{"label":_vm._f("languageByIsoCode")(_vm.locale),"occupy-validation-space":false,"hide-checked-label":"","label-inline":"","size":"xsmall"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }